/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { AzureAD } from 'react-aad-msal';
import getAuthProvider from '../auth/authProvider';
import { isIFrame } from '@jda/lui-portal-utilities';

type WrapperProps = {
  children?: React.ReactNode;
};

const { AUTH_METHOD } = window['env'];

export const AzureADWrapper = ({ children }: WrapperProps) => {
  if (isIFrame() || AUTH_METHOD === 'STATIC') {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return (
      // @ts-ignore: Unreachable code error
      <AzureAD provider={getAuthProvider()} forceLogin={true}>
        {children}
      </AzureAD>
    );
  }
};
